import styled from 'styled-components';
import { Device } from '../constants';
import { BaseProps } from './Container';

export const FlexWrap = styled.div<BaseProps>`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;

  @media screen and (max-width: ${Device.Tablet}) {
    margin: 0.5rem;
  }
`;
